import * as types from '../mutation-type/filters'

// state
export const state = {
  // Tags State Management
  popularTagId: null,
  popularTagFilter: null,
  myTagFilter: null,
  selectedTagType: 'my_tags'
}

// getters
export const getters = {
  // Tags state management
  popularTagId: (state) => state.popularTagId,
  popularTagFilter: (state) => state.popularTagFilter,
  myTagFilter: (state) => state.myTagFilter,
  selectedTagType: (state) => state.selectedTagType
}

// mutation
export const mutations = {
  [types.UPDATE_FILTER] (state, payload) {
    if (payload.type === 'my_tags') {
      state.myTagFilter = payload.filter
    }
    if (payload.type === 'popular_tags') {
      state.popularTagFilter = payload.filter
      state.popularTagId = payload.filter.tag_ids[0]
    }
    state.selectedTagType = payload.type
  },
  [types.UPDATE_POPULAR_TAG_FILTER] (state, payload) {
    state.popularTagFilter = payload
  },
  [types.UPDATE_SELECTED_TYPE] (state, type) {
    state.selectedTagType = type
  },
  [types.CLEAR_TAGS_FILTERS] (state) {
    state.popularTagFilter = null
    state.myTagFilter = null
  },
  [types.CLEAR_MY_TAGS_FILTERS] (state) {
    state.myTagFilter = null
  },
  [types.CLEAR_POPULAR_TAG_FILTERS] (state) {
    state.popularTagFilter = null
  }
}

// actions
export const actions = {
  updateFilter ({ commit }, payload) {
    commit(types.UPDATE_FILTER, payload)
  },
  updatePopularTagFilter ({ commit }, payload) {
    commit(types.UPDATE_POPULAR_TAG_FILTER, payload)
  },
  updateSelectedType ({ commit }, type) {
    commit(types.UPDATE_SELECTED_TYPE, type)
  },
  clearTagsFilters ({ commit }) {
    commit(types.CLEAR_TAGS_FILTERS)
  },
  clearMyTagsFilters ({ commit }) {
    commit(types.CLEAR_MY_TAGS_FILTERS)
  },
  clearPopularTagFilters ({ commit }) {
    commit(types.CLEAR_POPULAR_TAG_FILTERS)
  }
}
